"use client";
// beui.dev/components/blocks/not-found
// Restyled for Bavimail: the terminal is the blueprint code well (no traffic
// lights), the prompt cursor is Signal Orange.

import { TextReveal } from "@/components/motion/text-reveal";
import { NOT_FOUND_DEFAULTS, NotFoundActions, NotFoundStage, type NotFoundProps } from "./shared";

const TYPE_SPRING = { stiffness: 320, damping: 30, mass: 0.6 };

export function NotFoundTerminal({
  className,
  code = NOT_FOUND_DEFAULTS.code,
  title = NOT_FOUND_DEFAULTS.title,
  description = NOT_FOUND_DEFAULTS.description,
  homeHref,
  homeLabel,
  browseHref,
  browseLabel,
}: NotFoundProps) {
  return (
    <NotFoundStage className={className}>
      <div className="w-full max-w-md overflow-hidden rounded-sm border border-dashed border-hb-card bg-hb-inset text-left">
        <div className="flex items-center gap-2 border-b border-dashed border-hb-card px-4 py-2.5">
          <span className="h-1.5 w-1.5 bg-hb-accent" />
          <span className="font-mono-hb text-[10px] uppercase tracking-[0.18em] text-hb-muted">
            ~/bavimail
          </span>
        </div>
        <div className="space-y-1.5 p-4 font-mono-hb text-[13px] leading-relaxed">
          <TextReveal
            as="p"
            split="char"
            stagger={0.018}
            blur={6}
            yOffset={0}
            spring={TYPE_SPRING}
            className="text-hb-text"
            text="$ cd /page"
          />
          <TextReveal
            as="p"
            split="char"
            stagger={0.012}
            delay={0.45}
            blur={6}
            yOffset={0}
            spring={TYPE_SPRING}
            className="text-hb-danger-text"
            text="cd: no such file or directory: /page"
          />
          <p className="flex items-center text-hb-text">
            <TextReveal
              as="span"
              split="char"
              stagger={0.018}
              delay={1.1}
              blur={6}
              yOffset={0}
              spring={TYPE_SPRING}
              text={`$ status ${code}`}
            />
            <span className="ml-1 inline-block h-[1.1em] w-[0.55ch] translate-y-[0.12em] bg-hb-accent motion-safe:animate-pulse" />
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center gap-2">
        <h1 className="font-hb text-2xl font-extrabold tracking-tight text-hb-heading">{title}</h1>
        <p className="max-w-sm font-hb text-sm leading-relaxed text-hb-muted">{description}</p>
      </div>

      <NotFoundActions
        homeHref={homeHref}
        homeLabel={homeLabel}
        browseHref={browseHref}
        browseLabel={browseLabel}
      />
    </NotFoundStage>
  );
}
